/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './transfer-search-result.scss';
import { FormattedMessage } from 'react-intl';
import LabeledNode from '../../../../sharedmodules/components/labeled-node';
import LabeledString from '../../../../sharedmodules/components/labeled-string';
import PropTypes from 'prop-types';
import React from 'react';
import Transfer from '../state/dealerTransferResponse';
import { buildDate } from '../../../../sharedmodules/services/builld-date';
import { buildDealer } from '../../../../sharedmodules/services/build-dealer';

class TransferSearchResult extends React.Component {

    constructor() {

        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleDecline = this.handleDecline.bind(this);

    }

    componentWillMount() {

        this.setState({
            approverComment: this.props.transfer.approverComment,
        });

    }

    handleChange(event) {

        this.setState({
            approverComment: event.target.value,
        });

    }

    handleBlur(event) {

        const newTransfer = { ...this.props.transfer };

        newTransfer.approverComment = event.target.value;

        this.props.actions.updateTransferComment(newTransfer);

    }

    handleDecline() {

        const newTransfer = { ...this.props.transfer };
        newTransfer.status = 'REJECTED';
        this.props.actions.updateTransferStatus(this.props.auth.getAccessToken, newTransfer);

    }

    handleAccept() {

        const newTransfer = { ...this.props.transfer };
        newTransfer.status = 'ACCEPTED';
        this.props.actions.updateTransferStatus(this.props.auth.getAccessToken, newTransfer);

    }

    render() {

        return (
            <section className="transfer-search-result">
                <section>
                    <main>
                        <div className="product-header">
                            <span
                                className="product-title"
                            >
                                {this.props.transfer.product.pin}
                            </span>
                            <div
                                className="account-status"
                            >
                                <span
                                    className="dot-icon-red"
                                />
                                <FormattedMessage
                                    id={this.props.transfer.status}
                                />

                            </div>
                        </div>
                        <div className="data-pairs">
                            <div className="row">
                                <LabeledString
                                    className="current-dealer"
                                    data={buildDealer(this.props.transfer.currentDealer, '08')}
                                    label="CURRENT_DEALER_LOCATION"
                                />
                                <LabeledNode
                                    className="build-user-name"
                                    data={this.props.transfer.requestedBy.buildUserName() ||
                                        <FormattedMessage id="NO_USER_FOUND" />}
                                    label="REQUESTED_BY"
                                />
                            </div>
                            <div className="row">
                                <LabeledString
                                    className="new-dealer"
                                    data={buildDealer(this.props.transfer.newDealer, '08')}
                                    label="NEW_DEALER_LOCATION"
                                />
                                <LabeledString
                                    className="request-date"
                                    data={buildDate(this.props.transfer.requestDate)}
                                    label="REQUESTED_DATE"
                                />
                            </div>
                            <div className="row">
                                <LabeledNode
                                    className="customer-link-item"
                                    data={this.props.transfer.product.customerSummary.displayName}
                                    label="CUSTOMER"
                                />
                            </div>
                        </div>
                    </main>
                </section>
                <footer>
                    <span className="reason-for-change">
                        <textarea
                            disabled
                            rows={4}
                            value={this.props.transfer.reasonForChange}
                        />
                    </span>
                    <span className="approver-comment">
                        <textarea
                            disabled={this.props.transfer.status !== 'NEW'}
                            maxLength={119}
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            placeholder="ENTER_COMMENTS_BEFORE_ACCEPTING"
                            rows={4}
                            value={this.state.approverComment}
                        />
                    </span>
                    { this.props.transfer.status === 'NEW' && (
                        <section className="button-group">
                            <button
                                type="button"
                                className="secondary"
                                onClick={this.handleDecline}
                            >
                                <FormattedMessage id="REJECT" />
                            </button>
                            <button
                                type="button"
                                className="primary"
                                onClick={this.handleAccept}
                            >
                                <FormattedMessage id="ACCEPT" />
                            </button>
                        </section>
                    )}
                </footer>
            </section>
        );

    }

}

TransferSearchResult.displayName = 'TransferSearchResult';
TransferSearchResult.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    transfer: PropTypes.instanceOf(Transfer).isRequired,
    updateCommentAction: PropTypes.func,
};

export default TransferSearchResult;
